import type { EntityConnectionCoreFragment } from 'generated/graphql';
import { pick } from 'lodash-es';

import { isNilOrEmpty } from 'helpers';

export function filterConnectionsOnText(
  connections: EntityConnectionCoreFragment[],
  term: string,
  excludeEntityId: string = null
) {
  if (isNilOrEmpty(term)) {
    return connections;
  }
  return connections.filter(c => {
    const searchable = [c.entity1, c.entity2]
      .filter(e => e.id !== excludeEntityId)
      .map(e => pick(e, ['firstName', 'lastName', 'middleName', 'nickname']));

    return JSON.stringify(searchable).toUpperCase().includes(term.toUpperCase());
  });
}
